/* Quaza blog article behaviours. Extracted verbatim from
   sections/quaza-article.liquid on 2026-08-02 so it can be cached, and so the
   card-list explorer can be added without pushing the section past 600 lines.
   Behaviour-identical to the inline version. Config arrives on window.QB_ARTICLE_CFG. */
(function () {
  'use strict';

  var root = document.querySelector('[data-qb]');

  /* Theme toggle — same behavior and storage key as Quaza Track */
  var themeBtn = root ? root.querySelector('[data-qb-theme]') : null;
  if (themeBtn) {
    var themeLabel = function () { themeBtn.setAttribute('aria-label', root.getAttribute('data-theme') === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'); };
    themeLabel();
    themeBtn.addEventListener('click', function () {
      var dark = root.getAttribute('data-theme') === 'dark';
      if (dark) root.removeAttribute('data-theme');
      else root.setAttribute('data-theme', 'dark');
      try { localStorage.setItem('qpt-theme', dark ? 'light' : 'dark'); } catch (e) { /* private browsing */ }
      themeLabel();
    });
  }

  /* Reading progress ------------------------------------------------ */
  var bar = document.getElementById('qbProgressBar');
  var prose = document.getElementById('qbProse');
  function onScroll() {
    if (!bar || !prose) return;
    var rect = prose.getBoundingClientRect();
    var total = rect.height - window.innerHeight;
    var done = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
    bar.style.width = (total > 0 ? (done / total) * 100 : 0) + '%';
    var topBtn = document.getElementById('qbTop');
    if (topBtn) topBtn.classList.toggle('is-visible', window.scrollY > 900);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var topBtn = document.getElementById('qbTop');
  if (topBtn) topBtn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  /* Table of contents ---------------------------------------------- */
  var headings = prose ? prose.querySelectorAll('h2, h3') : [];
  var tocD = document.getElementById('qbTocDesktop');
  var tocM = document.getElementById('qbTocMobile');
  var tocLinks = [];
  if (headings.length >= 2 && tocD) {
    headings.forEach(function (h, i) {
      if (h.closest('.qb-sources, .qb-cta, .qb-track')) return;
      if (!h.id) h.id = 'section-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
      [tocD, tocM].forEach(function (list) {
        if (!list) return;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        a.dataset.level = h.tagName === 'H3' ? '3' : '2';
        li.appendChild(a);
        list.appendChild(li);
        if (list === tocD) tocLinks.push(a);
      });
    });
    var mWrap = document.getElementById('qbTocMobileWrap');
    if (mWrap && tocM && tocM.children.length) mWrap.hidden = false;

    if ('IntersectionObserver' in window && tocLinks.length) {
      var current = null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            current = en.target.id;
            tocLinks.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + current); });
          }
        });
      }, { rootMargin: '-80px 0px -70% 0px', threshold: 0 });
      headings.forEach(function (h) { if (h.id) io.observe(h); });
    }
  }

  /* Countdown: <div data-qb-countdown data-date="2026-09-16T00:00:00-04:00" data-label="..."> */
  document.querySelectorAll('[data-qb-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-date')).getTime();
    if (isNaN(target)) return;
    el.classList.add('qb-countdown');
    el.innerHTML =
      '<div class="qb-countdown__label">' + (el.getAttribute('data-label') || 'Releases in') + '</div>' +
      '<div class="qb-countdown__units">' +
      ['Days', 'Hours', 'Min', 'Sec'].map(function (u) {
        return '<div class="qb-countdown__unit"><div class="qb-countdown__num" data-u="' + u + '">0</div><div class="qb-countdown__unitlabel">' + u + '</div></div>';
      }).join('') +
      '</div><div class="qb-countdown__donetext">' + (el.getAttribute('data-done') || 'Available now') + '</div>';
    var nums = {};
    el.querySelectorAll('[data-u]').forEach(function (n) { nums[n.getAttribute('data-u')] = n; });
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { el.classList.add('qb-countdown--done'); clearInterval(iv); return; }
      nums.Days.textContent = Math.floor(diff / 864e5);
      nums.Hours.textContent = String(Math.floor(diff / 36e5) % 24).padStart(2, '0');
      nums.Min.textContent = String(Math.floor(diff / 6e4) % 60).padStart(2, '0');
      nums.Sec.textContent = String(Math.floor(diff / 1e3) % 60).padStart(2, '0');
    }
    var iv = setInterval(tick, 1000);
    tick();
  });

  /* Quaza Track hydration: bodies can embed live tracker data.
     - <td data-qb-live-price="<id>"> gets today's tracked CAD price
     - <div class="qb-prodgrid" data-qb-prodgrid="<set_name>" hidden> becomes a
       browseable card grid of that set's tracked products (image, price, 7d
       move), each card linking to its tracker product page
     - <a class="qb-idx" data-qb-index="<set_name>" hidden> becomes that set's
       live index card (level, 7d move, sparkline)
     Same API and cache the tracker page uses; placeholders stay put and
     hidden blocks stay hidden if a fetch fails. */
  /* Prices come from the static price files through QuazaTrackData (assets/quaza-track-data.js,
     loaded before this file), never from the prices Worker the iOS app depends on (2026-10). */
  var QB_DATA = window.QuazaTrackData;
  /* Set by the inline config block in sections/quaza-article.liquid, because a
     .js asset cannot carry Liquid. Same default as the old interpolation. */
  var TRACK_URL = (window.QB_ARTICLE_CFG && window.QB_ARTICLE_CFG.trackUrl) ||
    ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/price-tracker';
  /* Thousands separator matters now that single cards clear $1,000 (Storm
     Emeralda SAR 110 was the first). Same grouping regex the 31 set-tracker
     pages use, so a price reads identically wherever it appears. */
  function qbCad(cents) {
    var n = (cents / 100).toFixed(2).split('.');
    return 'CA$' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
  }
  /* A Track market price (CAD cents) in the shopper's currency: the code and the CAD -> currency factor
     come from QB_ARTICLE_CFG (shop track.rates, the rates the server-printed prices use). It printed CA$
     in every market until 2026-10-14 (US$ pages showed CA$ cards). 'en' keeps Canada's text exactly as it
     was ("CA$1,872.80") and prints "$" in the US, "€" in the eurozone, "£" in the UK. No rate or an
     unknown code: CA$, never a CAD figure under another currency's sign. */
  var QB_CUR = (window.QB_ARTICLE_CFG && window.QB_ARTICLE_CFG.currency) || 'CAD';
  var QB_RATE = window.QB_ARTICLE_CFG && window.QB_ARTICLE_CFG.cadRate;
  var qbFmt = null;
  if (QB_CUR !== 'CAD' && QB_RATE > 0) {
    try { qbFmt = new Intl.NumberFormat('en', { style: 'currency', currency: QB_CUR }); } catch (e) { qbFmt = null; }
  }
  function qbMoney(cents) {
    return qbFmt ? qbFmt.format((cents / 100) * QB_RATE) : qbCad(cents);
  }
  /* The posts' live-price columns are headed in CAD ("Live (CAD)", "CAD · live", "Quaza Track, CAD"), so
     once a cell converts, its column header names the shopper's currency instead. Whole word only. */
  function qbRelabel(cell) {
    if (!qbFmt) return;
    var table = cell.closest('table');
    var row = cell.closest('tr');
    if (!table || !row) return;
    var col = [].indexOf.call(row.cells, cell);
    var head = table.tHead && table.tHead.rows[0];
    var th = head && head.cells[col];
    if (!th || th.hasAttribute('data-qb-cur')) return;
    th.setAttribute('data-qb-cur', QB_CUR);
    var walk = document.createTreeWalker(th, NodeFilter.SHOW_TEXT);
    while (walk.nextNode()) walk.currentNode.nodeValue = walk.currentNode.nodeValue.replace(/\bCAD\b/g, QB_CUR);
  }
  /* Under the MSRP basis an index level IS a premium, so say it in words. A bare
     "352.5" on an article card tells a reader nothing and reads like a price.
     Matches the wording used on the tracker itself and on the set tracker pages. */
  function qbPremium(level) {
    var d = Math.round(level - 100);
    if (d === 0) return 'Trading at MSRP';
    return d > 0 ? 'Trading ' + d + '% above MSRP' : 'Trading ' + Math.abs(d) + '% below MSRP';
  }
  function qbPill(chg) {
    var up = chg >= 0;
    var s = document.createElement('span');
    s.className = 'qb-pillchg ' + (up ? 'qb-pillchg--up' : 'qb-pillchg--down');
    s.textContent = (up ? '▲ ' : '▼ ') + Math.abs(chg).toFixed(1) + '%';
    return s;
  }
  function qbSpark(series, chg) {
    var pts = (series || []).map(function (d) { return d[1]; }).filter(function (v) { return typeof v === 'number'; });
    if (pts.length < 2) return null;
    var min = Math.min.apply(null, pts), max = Math.max.apply(null, pts);
    var span = (max - min) || 1;
    var W = 220, H = 48, pad = 3;
    var coords = pts.map(function (v, i) {
      var x = (i / (pts.length - 1)) * W;
      var y = pad + (1 - (v - min) / span) * (H - pad * 2);
      return x.toFixed(1) + ' ' + y.toFixed(1);
    });
    var color = chg >= 0 ? '#62a56e' : '#d9596c';
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    var line = document.createElementNS(ns, 'path');
    line.setAttribute('d', 'M' + coords.join(' L'));
    line.setAttribute('fill', 'none');
    line.setAttribute('stroke', color);
    line.setAttribute('stroke-width', '2');
    line.setAttribute('stroke-linejoin', 'round');
    line.setAttribute('stroke-linecap', 'round');
    var area = document.createElementNS(ns, 'path');
    area.setAttribute('d', 'M' + coords.join(' L') + ' L' + W + ' ' + H + ' L0 ' + H + ' Z');
    area.setAttribute('fill', color);
    area.setAttribute('fill-opacity', '0.12');
    svg.appendChild(area);
    svg.appendChild(line);
    return svg;
  }

  var liveCells = document.querySelectorAll('[data-qb-live-price]');
  var prodGrids = document.querySelectorAll('[data-qb-prodgrid]');
  var idxCards = document.querySelectorAll('[data-qb-index]');

  /* Data comes from /indexes/set/<set_name>, one small call per set the article
     names, NOT from /catalog + /indexes.

     Those two cost ~166KB and ~110KB on the wire and about 4,100 and 35,000 D1
     rows respectively, on EVERY article view. D1's free tier stops answering
     queries past 5M row reads in a day and fails closed for every consumer of
     the database, the iOS app included, so the blog was the single largest
     exposure on the store. A set page costs ~400 rows instead.

     Nearly every data-qb-live-price id belongs to a set this article already
     names (measured: 5 exceptions across all 35 articles), so the per-set
     payloads cover them. The few that do not fall back to /prices/<id>, which is
     ~91 rows each rather than /catalog's ~4,100. */
  var qbSetsPromise = null;
  function qbLoadSets(names) {
    // Memoised: the product grid, the live-price cells and the index cards all
    // want the same sets, and without this each consumer fires its own identical
    // request. One call, shared.
    if (qbSetsPromise) return qbSetsPromise;
    qbSetsPromise = Promise.all(names.map(function (n) {
      if (!QB_DATA) return Promise.resolve(null);
      return QB_DATA.setIndex(n).catch(function () { return null; });
    })).then(function (list) {
      var sets = [], byId = {};
      list.forEach(function (d) {
        if (!d || d.error) return;
        sets.push(d);
        (d.products || []).forEach(function (p) { byId[p.id] = p; });
      });
      return { sets: sets, byId: byId };
    });
    return qbSetsPromise;
  }

  var qbSetNames = [];
  [].forEach.call(prodGrids, function (g) { qbSetNames.push(g.getAttribute('data-qb-prodgrid')); });
  [].forEach.call(idxCards, function (c) { qbSetNames.push(c.getAttribute('data-qb-index')); });
  qbSetNames = qbSetNames.filter(function (n, i) { return n && qbSetNames.indexOf(n) === i; });

  if (qbSetNames.length || liveCells.length) {
    qbLoadSets(qbSetNames)
      .then(function (data) {
        var by = data.byId;
        var setOf = {};
        data.sets.forEach(function (d) { setOf[d.set_name] = d; });

        var missing = [];
        liveCells.forEach(function (cell) {
          var id = cell.getAttribute('data-qb-live-price');
          var p = by[id];
          if (p && p.price_cents) { cell.textContent = qbMoney(p.price_cents); qbRelabel(cell); }
          else if (!p) missing.push(cell);
        });

        // Products from a set this article does not name: one cheap call each.
        missing.forEach(function (cell) {
          var id = cell.getAttribute('data-qb-live-price');
          if (!QB_DATA) return;
          QB_DATA.product(id)
            .then(function (d) { if (d && d.current_cents) { cell.textContent = qbMoney(d.current_cents); qbRelabel(cell); } })
            .catch(function () { /* placeholder stays */ });
        });

        prodGrids.forEach(function (grid) {
          var setName = grid.getAttribute('data-qb-prodgrid');
          var setShort = setName.split(': ').pop();
          var src = setOf[setName];
          var members = src ? (src.products || []).slice() : [];
          members.sort(function (a, b) { return (a.sort_order || 0) - (b.sort_order || 0) || a.name.localeCompare(b.name); });
          if (!members.length) return;
          members.forEach(function (p) {
            var a = document.createElement('a');
            a.className = 'qb-prodcard';
            a.href = TRACK_URL + '?product=' + encodeURIComponent(p.id);
            var imgWrap = document.createElement('div');
            imgWrap.className = 'qb-prodcard__img';
            if (p.image_url) {
              var img = document.createElement('img');
              img.src = p.image_url;
              img.alt = p.name;
              img.loading = 'lazy';
              /* a dead image URL in Track's data (one Surging Sparks product answers 403 to everyone,
                 13 Oct) leaves the plain tile, not a broken-image icon */
              img.addEventListener('error', function () { img.remove(); });
              imgWrap.appendChild(img);
            }
            a.appendChild(imgWrap);
            var nm = document.createElement('p');
            nm.className = 'qb-prodcard__name';
            nm.textContent = p.name.indexOf(setShort + ' ') === 0 ? p.name.slice(setShort.length + 1) : p.name;
            a.appendChild(nm);
            var foot = document.createElement('div');
            foot.className = 'qb-prodcard__foot';
            if (p.price_cents) {
              var pr = document.createElement('span');
              pr.className = 'qb-prodcard__price';
              pr.textContent = qbMoney(p.price_cents);
              foot.appendChild(pr);
            }
            if (typeof p.change7d_pct === 'number') foot.appendChild(qbPill(p.change7d_pct));
            a.appendChild(foot);
            grid.appendChild(a);
          });
          grid.hidden = false;
        });
      })
      .catch(function () { /* placeholders stay */ });
  }

  if (idxCards.length) {
    /* basis is msrp_anchored on this route by definition, matching the tracker,
       the set pages and the article prose. level === null means the set is not
       in the MSRP basis right now (pre-release), so the card stays hidden rather
       than showing a level on the wrong basis. */
    qbLoadSets(qbSetNames)
      .then(function (data) {
        var setOf = {};
        data.sets.forEach(function (d) { setOf[d.set_name] = d; });
        idxCards.forEach(function (card) {
          var setName = card.getAttribute('data-qb-index');
          var s = setOf[setName];
          if (!s || typeof s.level !== 'number') return;
          card.href = TRACK_URL + '?index=' + encodeURIComponent('set:' + setName);
          /* no caps kicker above the name (decoration, owner's pick 13 Oct); the meta line names Track */
          var row = document.createElement('div');
          row.className = 'qb-idx__row';
          var nm = document.createElement('span');
          nm.className = 'qb-idx__name';
          nm.textContent = s.set_name.split(': ').pop() + ' Index';
          row.appendChild(nm);
          var lv = document.createElement('span');
          lv.className = 'qb-idx__level';
          lv.textContent = s.level.toFixed(1);
          row.appendChild(lv);
          if (typeof s.change_pct === 'number') row.appendChild(qbPill(s.change_pct));
          var spark = qbSpark(s.series, s.change_pct || 0);
          if (spark) {
            var sw = document.createElement('span');
            sw.className = 'qb-idx__spark';
            sw.appendChild(spark);
            row.appendChild(sw);
          }
          card.appendChild(row);
          var meta = document.createElement('div');
          meta.className = 'qb-idx__meta';
          meta.textContent = qbPremium(s.level) + '. Equal-weight across ' +
            ((s.covered == null ? s.count : s.covered)) +
            ' sealed products, 100 = MSRP at release. Tap for the full chart on Quaza Track.';
          card.appendChild(meta);
          card.hidden = false;
        });
      })
      .catch(function () { /* card stays hidden */ });
  }

  /* Numeric parsing for sortable columns. Shared by the sortable table and the
     card-list explorer so both order things the same way.

     The old comparator was parseFloat(text.replace(/[^0-9.\-]/g,'')), whose
     character class keeps only the ASCII hyphen. U+2212 MINUS SIGN is the glyph
     the house style uses for .qb-down, so it was stripped and every negative
     sorted as its own positive: a column of -57%, -43%, +18% ordered as
     +18, -43, -57. That was live on 35 published articles.

     Returns null, never NaN or 0, for anything with no digits ('', 'N/A',
     'TBA', an unhydrated price cell). Callers sink nulls in both directions. */
  function qbNum(text) {
    if (text == null) return null;
    var s = String(text)
      .replace(/−/g, '-')            // MINUS SIGN
      .replace(/[–—]/g, '-')    // en dash, em dash
      .replace(/,/g, '')                  // thousands separators
      .replace(/[^\d.+-]/g, '');          // currency symbols, %, letters, spaces
    if (!/\d/.test(s)) return null;
    var m = s.match(/[-+]?\d+(?:\.\d+)?/); // first number only, so '1000-2000' is 1000
    if (!m) return null;
    var n = parseFloat(m[0]);
    return isNaN(n) ? null : n;
  }
  window.qbNum = qbNum;

  /* Sortable tables: table.qb-table--sort ---------------------------- */
  document.querySelectorAll('table.qb-table--sort').forEach(function (table) {
    var tbody = table.tBodies[0];
    if (!tbody) return;
    var heads = Array.prototype.slice.call(table.querySelectorAll('thead th'));

    /* A cell may carry data-qb-sort to override its text. That is how rarity,
       dates and anything else unparseable get correct ordering without new
       comparator logic. */
    function keyOf(row, i) {
      var td = row.cells[i];
      if (!td) return { n: null, t: '' };
      var ov = td.getAttribute('data-qb-sort');
      var raw = ov !== null ? ov : (td.textContent || '');
      return { n: qbNum(raw), t: raw.trim() };
    }

    function sortBy(th, colIdx) {
      var asc = !th.classList.contains('asc');
      heads.forEach(function (o) {
        o.classList.remove('asc', 'desc');
        o.setAttribute('aria-sort', 'none');
      });
      th.classList.add(asc ? 'asc' : 'desc');
      th.setAttribute('aria-sort', asc ? 'ascending' : 'descending');

      var rows = Array.prototype.slice.call(tbody.rows);
      var order = new Map();
      rows.forEach(function (r, i) { order.set(r, i); });

      rows.sort(function (a, b) {
        var ak = keyOf(a, colIdx), bk = keyOf(b, colIdx), cmp;
        /* Blanks sink in BOTH directions: return before applying asc/desc. */
        if (ak.n === null && bk.n === null) cmp = ak.t.localeCompare(bk.t);
        else if (ak.n === null) return 1;
        else if (bk.n === null) return -1;
        else cmp = ak.n - bk.n;
        if (cmp === 0) return order.get(a) - order.get(b);  // stable
        return asc ? cmp : -cmp;
      });
      rows.forEach(function (r) { tbody.appendChild(r); });
    }

    /* The header stays a column header (aria-sort is only valid there; role="button" on the <th>
       took that away and left a 33 px target on phones). A real button inside it takes the tap and
       the keyboard, 44 px tall. */
    heads.forEach(function (th, colIdx) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qb-sortbtn';
      while (th.firstChild) btn.appendChild(th.firstChild);
      th.appendChild(btn);
      th.setAttribute('aria-sort', 'none');
      btn.addEventListener('click', function () { sortBy(th, colIdx); });
    });
  });

  /* Filterable card gallery: [data-qb-gallery] with .qb-chip buttons
     (data-qb-filter) and .qb-gcard figures (data-qb-cat, space-separated) */
  document.querySelectorAll('[data-qb-gallery]').forEach(function (gal) {
    var chips = gal.querySelectorAll('[data-qb-filter]');
    var cards = gal.querySelectorAll('[data-qb-cat]');
    if (!chips.length || !cards.length) return;
    chips.forEach(function (chip) {
      chip.setAttribute('aria-pressed', chip.classList.contains('is-active') ? 'true' : 'false');
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-qb-filter');
        chips.forEach(function (c) {
          c.classList.toggle('is-active', c === chip);
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        cards.forEach(function (card) {
          card.hidden = f !== 'all' && (' ' + card.getAttribute('data-qb-cat') + ' ').indexOf(' ' + f + ' ') === -1;
        });
      });
    });
  });

  /* Wide tables on phones -------------------------------------------
     A five-column comparison table cannot fit 375px however short its headers
     are: each .num cell is nowrap, so a column's minimum is the widest figure it
     holds (~62px) plus padding, and five of those exceed the 333px available.
     Shortening the labels did not help and never could.

     So tables with five or more columns restructure into labelled rows on
     phones. The label comes from the matching <th>, copied here rather than
     authored into every body, which means it works on the 35 published articles
     that already carry sortable tables without touching any of them.

     The explorer's own card list is excluded: it has a purpose-built two-line
     layout that beats a generic label/value stack. */
  document.querySelectorAll('table.qb-table:not(.qb-cardlist)').forEach(function (table) {
    var head = table.tHead && table.tHead.rows[0];
    var tb = table.tBodies[0];
    if (!head || !tb) return;
    var labels = Array.prototype.map.call(head.cells, function (th) { return th.textContent.trim(); });
    if (labels.length < 5) return;
    table.classList.add('qb-table--stack');
    Array.prototype.forEach.call(tb.rows, function (tr) {
      Array.prototype.forEach.call(tr.cells, function (td, i) {
        if (labels[i] && !td.hasAttribute('data-label')) td.setAttribute('data-label', labels[i]);
      });
    });
  });

  /* Card-list explorer: [data-qb-explorer] ---------------------------
     Deliberately a separate handler rather than an extension of the gallery
     above. The gallery's chips are a radio group by construction, one string of
     state, and that behaviour is baked into 37 published bodies; making it
     multi-select would silently change every one of them.

     Filtering is instant via `hidden`. No stagger, no fade: 113 rows on a 30ms
     stagger is a 3.4 second wait dressed up as polish. */
  document.querySelectorAll('[data-qb-explorer]').forEach(function (root) {
    var table = root.querySelector('.qb-cardlist');
    var tbody = table && table.tBodies[0];
    if (!tbody) return;

    var rows = Array.prototype.slice.call(tbody.rows);
    var facets = Array.prototype.slice.call(root.querySelectorAll('[data-qb-facet]'));
    var search = root.querySelector('[data-qb-search]');
    var sortSel = root.querySelector('select[data-qb-sort]');  /* the select only: rarity cells carry data-qb-sort too */
    var countEl = root.querySelector('.qb-count');
    var resetBtn = root.querySelector('.qb-reset');
    var emptyEl = root.querySelector('.qb-explorer__empty');

    var state = { q: '', sort: 'no-asc', view: 'table' };
    facets.forEach(function (f) { state[f.getAttribute('data-qb-facet')] = new Set(); });

    var order = new Map();
    rows.forEach(function (r, i) { order.set(r, i); });

    function rowVal(row, key) { return row.getAttribute('data-qb-' + key) || ''; }

    /* Height cap. The list is clipped to about a screen and expands on demand,
       because 113 rows is roughly 5,650px of scroll. Injected rather than emitted
       into the body so published articles do not need rebuilding.
       CAP_ROWS is a count, not a pixel height, so the copy can say how many are
       hidden and the number stays honest as rows are filtered. */
    var CAP_ROWS = 12;
    var wrap = root.querySelector('.qb-cardwrap');
    var showAll = null;
    if (wrap) {
      showAll = document.createElement('button');
      showAll.type = 'button';
      showAll.className = 'qb-showall';
      showAll.setAttribute('aria-expanded', 'false');
      wrap.insertAdjacentElement('afterend', showAll);
      showAll.addEventListener('click', function () {
        var open = root.classList.toggle('is-expanded');
        showAll.setAttribute('aria-expanded', open ? 'true' : 'false');
        paintShowAll();
        if (!open) wrap.scrollIntoView({ block: 'start' });
      });
    }

    function paintShowAll() {
      if (!showAll) return;
      var shown = rows.filter(function (r) { return !r.hidden; }).length;
      /* Nothing to expand when the current filter already fits: drop the cap and
         the button rather than offering to reveal nothing. */
      var needsCap = shown > CAP_ROWS;
      root.classList.toggle('is-short', !needsCap);
      showAll.hidden = !needsCap;
      if (!needsCap) { root.classList.remove('is-expanded'); return; }
      showAll.textContent = root.classList.contains('is-expanded')
        ? 'Show fewer'
        : 'Show all ' + shown + ' cards';
    }

    /* AND across facet groups, OR within a group. An empty group means "any". */
    function matches(row, skipKey) {
      for (var i = 0; i < facets.length; i++) {
        var key = facets[i].getAttribute('data-qb-facet');
        if (key === skipKey) continue;
        var sel = state[key];
        if (sel.size && !sel.has(rowVal(row, key))) return false;
      }
      if (state.q && rowVal(row, 'search').indexOf(state.q) === -1) return false;
      return true;
    }

    var SORTS = {
      'no-asc':   function (a, b) { return qbNum(rowVal(a, 'no')) - qbNum(rowVal(b, 'no')); },
      'no-desc':  function (a, b) { return qbNum(rowVal(b, 'no')) - qbNum(rowVal(a, 'no')); },
      'name-asc': function (a, b) { return rowVal(a, 'name').localeCompare(rowVal(b, 'name')); },
      'hp-desc':  function (a, b) {
        var x = qbNum(rowVal(a, 'hp')), y = qbNum(rowVal(b, 'hp'));
        if (x === null && y === null) return 0;
        if (x === null) return 1;          /* blanks sink, both directions */
        if (y === null) return -1;
        return y - x;
      },
      'rarity':   function (a, b) { return qbNum(rowVal(b, 'rank')) - qbNum(rowVal(a, 'rank')); },
      /* Market price, highest first (WO4). Track prices print in whole units in the shopper's currency
         ("CA$1,350", "€1.350"), so every non-digit goes: qbNum would read "1.350" as 1.35. A row with no
         price sinks, as in the HP sort. */
      'price-desc': function (a, b) {
        var x = rowPx(a), y = rowPx(b);
        if (x === null && y === null) return 0;
        if (x === null) return 1;
        if (y === null) return -1;
        return y - x;
      }
    };

    function rowPx(row) {
      var el = row.querySelector('a.qb-px');
      if (!el) return null;
      /* qb-body.liquid writes the USD cents behind the figure; prices under 10 units print to the cent, so reading
         the text would rank "$4.41" (441) above "$67". The digit read stays for a page cached before the attribute. */
      var u = el.getAttribute('data-qb-u');
      if (u && /^\d+$/.test(u)) return parseInt(u, 10);
      var d = el.textContent.replace(/[^0-9]/g, '');
      return d ? parseInt(d, 10) : null;
    }

    function apply() {
      var shown = 0;
      rows.forEach(function (r) {
        var ok = matches(r);
        r.hidden = !ok;
        if (ok) shown++;
      });

      /* Chip counts recompute against the rest of the state, so a chip shows how
         many rows it would yield. Zero-yield chips are disabled rather than
         removed: hiding them reflows the toolbar, which reads as a bug. */
      facets.forEach(function (f) {
        var key = f.getAttribute('data-qb-facet');
        f.querySelectorAll('[data-qb-val]').forEach(function (chip) {
          var val = chip.getAttribute('data-qb-val');
          var n = 0;
          rows.forEach(function (r) {
            if (!matches(r, key)) return;
            if (val === 'all' || rowVal(r, key) === val) n++;
          });
          var b = chip.querySelector('b');
          if (b) b.textContent = n;
          if (val !== 'all') chip.disabled = n === 0;
          var on = val === 'all' ? state[key].size === 0 : state[key].has(val);
          chip.classList.toggle('is-active', on);
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });

      var cmp = SORTS[state.sort] || SORTS['no-asc'];
      var sorted = rows.slice().sort(function (a, b) {
        var c = cmp(a, b);
        return c === 0 ? order.get(a) - order.get(b) : c;   /* stable */
      });
      sorted.forEach(function (r) { tbody.appendChild(r); });

      paintShowAll();
      if (countEl) countEl.textContent = 'Showing ' + shown + ' of ' + rows.length;
      if (emptyEl) emptyEl.hidden = shown !== 0;

      var dirty = !!state.q || state.sort !== 'no-asc' ||
        facets.some(function (f) { return state[f.getAttribute('data-qb-facet')].size > 0; });
      if (resetBtn) resetBtn.hidden = !dirty;

      writeUrl();
    }

    /* Shareable state, so "all six SARs" is a link. */
    function writeUrl() {
      if (!history.replaceState) return;
      var p = new URLSearchParams();
      facets.forEach(function (f) {
        var k = f.getAttribute('data-qb-facet');
        if (state[k].size) p.set(k, Array.from(state[k]).join(','));
      });
      if (state.q) p.set('q', state.q);
      if (state.sort !== 'no-asc') p.set('sort', state.sort);
      var qs = p.toString();
      history.replaceState(null, '', qs ? '?' + qs + location.hash : location.pathname + location.hash);
    }

    function readUrl() {
      var p = new URLSearchParams(location.search);
      facets.forEach(function (f) {
        var k = f.getAttribute('data-qb-facet');
        var v = p.get(k);
        if (v) v.split(',').forEach(function (x) { if (x) state[k].add(x); });
      });
      state.q = (p.get('q') || '').toLowerCase();
      if (search && state.q) search.value = state.q;
      if (SORTS[p.get('sort')]) state.sort = p.get('sort');
      if (sortSel) sortSel.value = state.sort;
    }

    facets.forEach(function (f) {
      var key = f.getAttribute('data-qb-facet');
      f.querySelectorAll('[data-qb-val]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var val = chip.getAttribute('data-qb-val');
          if (val === 'all') state[key].clear();
          else if (state[key].has(val)) state[key].delete(val);
          else state[key].add(val);
          apply();
        });
      });
    });

    if (search) {
      var t = 0;
      search.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { state.q = search.value.trim().toLowerCase(); apply(); }, 150);
      });
    }
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(); });
    if (resetBtn) resetBtn.addEventListener('click', function () {
      facets.forEach(function (f) { state[f.getAttribute('data-qb-facet')].clear(); });
      state.q = ''; state.sort = 'no-asc';
      if (search) search.value = '';
      if (sortSel) sortSel.value = 'no-asc';
      apply();
      if (search) search.focus();
    });

    readUrl();
    apply();
  });

  /* Lightbox on article figures ------------------------------------- */
  var lb = document.getElementById('qbLightbox');
  if (lb && prose) {
    var lbImg = lb.querySelector('img');
    prose.addEventListener('click', function (e) {
      var img = e.target.closest('figure img');
      if (!img || img.closest('.qb-video')) return;
      lbImg.src = img.currentSrc || img.src;
      lbImg.alt = img.alt || '';
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    function closeLb() { lb.classList.remove('is-open'); document.body.style.overflow = ''; }
    lb.addEventListener('click', closeLb);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
  }

  /* WO5 modules (snippets/qb-mods.liquid) ---------------------------------------------------------------
     1. A picture that fails (a dead Track image, a moved file) leaves its tile with the name the server put on it
        (data-qb-name, drawn by qb-mods.css), never a broken image.
     2. The shelf's lead product: Track's own price chart (assets/price-chart.js, the Track page's widget) for the
        product's history, loaded when it nears the screen, into a box the stylesheet already sized. */
  [].forEach.call(document.querySelectorAll('.qb-shelf__img img, .qb-cards__img img, .qb-cost__img img, .qb-when__img img, .qb-chance__img img'), function (img) {
    function drop() { var box = img.parentNode; if (box) box.removeChild(img); }
    if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) drop();
    else img.addEventListener('error', drop);
  });

  var qbCharts = document.querySelectorAll('.qb-shelf__chart[data-qb-chart]');
  var CFG = window.QB_ARTICLE_CFG || {};
  if (qbCharts.length && QB_DATA && CFG.chartJs && CFG.usdCad) {
    var chartLib = null;
    var loadLib = function () {
      if (window.QuazaPriceChart) return Promise.resolve(window.QuazaPriceChart);
      if (!chartLib) {
        chartLib = new Promise(function (ok, no) {
          var s = document.createElement('script');
          s.src = CFG.chartJs; s.async = true;
          s.onload = function () { window.QuazaPriceChart ? ok(window.QuazaPriceChart) : no(); };
          s.onerror = no;
          document.head.appendChild(s);
        });
      }
      return chartLib;
    };
    var mountChart = function (box) {
      var id = box.getAttribute('data-qb-chart'), name = box.getAttribute('data-qb-chart-name') || '';
      loadLib().then(function (C) {
        C.setMoney(QB_CUR, QB_CUR === 'CAD' ? 1 : QB_RATE);
        C.renderWidget(box, {
          load: function (range) {
            return QB_DATA.history(id).then(function (e) {
              if (!e) throw new Error('no history');
              return QB_DATA.historyDetail(e, range, CFG.usdCad, null, { id: id, name: name });
            });
          },
          range: '3m',
          trackerUrl: TRACK_URL + '?product=' + encodeURIComponent(id)
        });
      }).catch(function () { box.hidden = true; });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); mountChart(en.target); } });
      }, { rootMargin: '400px 0px' });
      [].forEach.call(qbCharts, function (b) { io.observe(b); });
    } else {
      [].forEach.call(qbCharts, mountChart);
    }
  }

  /* Click-to-load video: <figure class="qb-video"><a href="<youtube-nocookie embed URL of the clip>" data-qb-yt="<id>">
     <img>...</a></figure>. The page carries only our own thumbnail, so a video costs no LCP and no third-party bytes.
     The tap swaps in the youtube-nocookie player, in place; with JS off the link opens the same clip. data-qb-yt-start
     and data-qb-yt-end (seconds) play one part of a longer video. The link is never a youtube.com/watch or youtu.be
     URL: Impulse's theme.videoModal binds those, loads YouTube's SDK with the page and plays the whole video in its
     own modal (PR #176 independent check). This listener also runs in the capture phase and stops the click there,
     so no other handler can take the tap. */
  if (prose) {
    prose.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-qb-yt]');
      if (!a) return;
      var id = a.getAttribute('data-qb-yt');
      if (!/^[\w-]{11}$/.test(id)) return;
      e.preventDefault();
      e.stopPropagation();
      var from = parseInt(a.getAttribute('data-qb-yt-start'), 10), to = parseInt(a.getAttribute('data-qb-yt-end'), 10);
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1' +
        (from > 0 ? '&start=' + from : '') + (to > 0 ? '&end=' + to : '');
      f.title = a.getAttribute('aria-label') || 'Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      f.className = 'qb-video__frame';
      a.replaceWith(f);
      f.focus();
    }, true);
  }

  /* Spotlight price check (snippets/qb-spot-price.liquid). Its eBay.ca snapshot shows for 14 days. The server checks
     the date, but a cached page can be older than that, so the reader's own clock has the last word: past the date
     the block and the buy card's line that points to it go. */
  var pcBox = document.querySelector('[data-qb-pc-until]');
  if (pcBox) {
    var pcUntil = pcBox.getAttribute('data-qb-pc-until'), pcD = new Date();
    var pcToday = pcD.getFullYear() + '-' + ('0' + (pcD.getMonth() + 1)).slice(-2) + '-' + ('0' + pcD.getDate()).slice(-2);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(pcUntil || '') || pcToday >= pcUntil) {
      pcBox.hidden = true;
      document.querySelectorAll('a[href="#qb-price-check"]').forEach(function (a) {
        var li = a.closest('li');
        if (li) li.hidden = true;
      });
    }
  }

  /* Copy link -------------------------------------------------------- */
  var copyBtn = document.getElementById('qbCopyLink');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var url = copyBtn.getAttribute('data-url');
      var label = copyBtn.querySelector('span');
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
        label.textContent = 'Copied!';
        setTimeout(function () { label.textContent = 'Copy link'; }, 2000);
      }).catch(function () { window.prompt('Copy this link:', url); });
    });
  }
})();
